"use client";
import { jsx } from "react/jsx-runtime";
import Cookie from "js-cookie";
import { useTracking } from "react-tracking";
import { COOKIE_DEBUG_ANALYTICS, TRACK_TYPE_NAVIGATION, TRACK_TYPE_SEARCH, TRACK_TYPE_AD, TRACK_TYPE_MULTI_ATTR, TRACK_TYPE_SOCIAL_SHARE, SAVE_TO_LIST, TRACK_TYPE_PDP_WHY_BUY, TRACK_TYPE_PDP_FULFILLMENT, TRACK_TYPE_PDP_ADD_TO_CART, TRACK_TYPE_PRODUCT_NOT_AVAILABLE, TRACK_TYPE_ATC_CONTINUE_SHOPPING, TRACK_TYPE_ATC_VIEW_CART, TRACK_TYPE_PDP_ACCORDION, TRACK_TYPE_PDP_PRODUCT_PRICE_CARD, TRACK_TYPE_PDP_PRODUCT_ACTION, TRACK_TYPE_EXTERNAL_LINK, TRACK_TYPE_OBJECT, TRACK_TYPE_VIEW } from "./constants.js";
import { processNavAnalyticData, processSearchAnalyticData, processAdAnalyticData, processMultiAttributeAnalyticData, processSocialShareAnalyticData, processProductNotFoundAnalytics, processATCContShopViewCart, processProductAccordionAnalytics, processViewExternalLinkModalAnalytics } from "./lib.js";
const COMPONENT_NAME = "Analytics";
const dispatchAnalytics = (data) => {
  if (data == null ? void 0 : data.doNotTrack) return;
  const debugAnalytics = Cookie.get(COOKIE_DEBUG_ANALYTICS);
  if (debugAnalytics) {
    console.log(
      "debug analytics : captured data = " + JSON.stringify(data)
    );
  }
  const trackHandlers = /* @__PURE__ */ new Map([
    [
      TRACK_TYPE_NAVIGATION,
      () => {
        var _a, _b;
        return ((_b = (_a = data.component) == null ? void 0 : _a.trackedData) == null ? void 0 : _b.length) ? processNavAnalyticData(data) : "";
      }
    ],
    [
      TRACK_TYPE_SEARCH,
      () => data.identifier ? processSearchAnalyticData(data) : ""
    ],
    [
      TRACK_TYPE_AD,
      () => Object.keys(data.adItem ?? {}).length ? processAdAnalyticData(data) : ""
    ],
    [
      TRACK_TYPE_MULTI_ATTR,
      () => {
        var _a;
        return ((_a = data.trackedData) == null ? void 0 : _a.length) ? processMultiAttributeAnalyticData(data) : "";
      }
    ],
    [
      TRACK_TYPE_SOCIAL_SHARE,
      () => {
        var _a;
        return ((_a = data == null ? void 0 : data.component) == null ? void 0 : _a.identifier) ? processSocialShareAnalyticData(data) : "";
      }
    ],
    [SAVE_TO_LIST, () => data == null ? void 0 : data.trackedData],
    [TRACK_TYPE_PDP_WHY_BUY, () => data == null ? void 0 : data.trackedData],
    [TRACK_TYPE_PDP_FULFILLMENT, () => data == null ? void 0 : data.trackedData],
    [TRACK_TYPE_PDP_ADD_TO_CART, () => data == null ? void 0 : data.trackedData],
    [
      TRACK_TYPE_PRODUCT_NOT_AVAILABLE,
      () => (data == null ? void 0 : data.component) ? processProductNotFoundAnalytics(data) : ""
    ],
    [
      TRACK_TYPE_ATC_CONTINUE_SHOPPING,
      () => (data == null ? void 0 : data.component) ? processATCContShopViewCart(data) : ""
    ],
    [
      TRACK_TYPE_ATC_VIEW_CART,
      () => (data == null ? void 0 : data.component) ? processATCContShopViewCart(data) : ""
    ],
    [
      TRACK_TYPE_PDP_ACCORDION,
      () => {
        var _a;
        return ((_a = data == null ? void 0 : data.component) == null ? void 0 : _a.identifier) ? processProductAccordionAnalytics(data) : "";
      }
    ],
    [
      TRACK_TYPE_PDP_PRODUCT_PRICE_CARD,
      () => {
        var _a;
        return ((_a = data == null ? void 0 : data.component) == null ? void 0 : _a.identifier) ? processProductAccordionAnalytics(data) : "";
      }
    ],
    [
      TRACK_TYPE_PDP_PRODUCT_ACTION,
      () => {
        var _a;
        return ((_a = data == null ? void 0 : data.component) == null ? void 0 : _a.identifier) ? processProductAccordionAnalytics(data) : "";
      }
    ],
    [
      TRACK_TYPE_EXTERNAL_LINK,
      () => {
        var _a;
        return ((_a = data == null ? void 0 : data.component) == null ? void 0 : _a.identifier) ? processViewExternalLinkModalAnalytics(data) : "";
      }
    ],
    [TRACK_TYPE_OBJECT, () => data.trackedData],
    [TRACK_TYPE_VIEW, () => ({ contentImp: data.contentImp })]
  ]);
  const handler = trackHandlers.get(data == null ? void 0 : data.trackType);
  const dispatchData = handler ? handler() : "";
  if (!dispatchData) return;
  if (debugAnalytics) {
    console.log(
      "debug analytics : submitted data = " + (typeof dispatchData === "string" ? dispatchData : JSON.stringify(dispatchData))
    );
  }
  window.digitalDataEvents = window.digitalDataEvents || [];
  window.digitalDataEvents.push(dispatchData);
};
const Analytics = ({
  analyticData,
  children,
  readyToDispatch
}) => {
  const { Track } = useTracking(analyticData ? analyticData : {}, {
    dispatch: readyToDispatch ? dispatchAnalytics : void 0
  });
  return /* @__PURE__ */ jsx(Track, { children });
};
Analytics.displayName = COMPONENT_NAME;
export {
  Analytics,
  dispatchAnalytics
};
